import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { HolidayAllowance } from "src/app/interfaces/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "HolidayAllowance";
export const HolidayAllowanceService = {
	endpoint,
	createAllowancesForYear: async (year: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/CreateAllowancesForYear/${year}`, {headers: {"Content-Type": "application/json"}, method: "POST"}),
	createSingle: async (data: HolidayAllowance) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	myAllowanceForYear: async (year: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/MyAllowanceForYear/${year}`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: HolidayAllowance) => await Service.updateSingleById(endpoint, id, data),
}